(function() {
  var $openSearchTrigger = $('.js-toggle-search-trigger');
  var $closeSearchTrigger = $('.js-header-search-form-wrapper img');
  var $headerSearchFormWrapper = $('.js-header-search-form-wrapper');
  //sp
  var $sp_$headerSearchFormWrapper = $('.header-logo,.header-tools,.ly-header-search-form-wrapper,.headerSearch-close-img');
  var $sp_closeSearchTrigger = $('.headerSearch-close-img');
  $openSearchTrigger.on('click', function() {
    $headerSearchFormWrapper.addClass('is-open');
  });
  $closeSearchTrigger.on('click', function() {
    $headerSearchFormWrapper.removeClass('is-open');
  });
  //sp
  $openSearchTrigger.on('click', function() {
    $sp_$headerSearchFormWrapper.addClass('is-close');
  });
  $sp_closeSearchTrigger.on('click', function() {
    $sp_$headerSearchFormWrapper.removeClass('is-close');
  });
})();
